import { jwtDecode } from "jwt-decode";
import React, { useEffect } from "react";
import { basicauth } from "../Utils/Credentials";

const clientId =
  "1080941448325-li5qeour49efnj34a0tl16q8fcrkdk7t.apps.googleusercontent.com";
let oneTapInitialized = false; // <— global guard

const GoogleOneTapLogin = () => {
  useEffect(() => {
    /* global google */

    const startOneTap = () => {
      if (oneTapInitialized) return; // Prevent multiple initializations
      oneTapInitialized = true;

      google.accounts.id.initialize({
        client_id: clientId,
        callback: handleCredentialResponse,
        auto_select: false,
        cancel_on_tap_outside: true,
        use_fedcm_for_prompt: true, // <— Important new flag for migration
      });

      google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed()) {
          console.log("Not displayed:", notification.getNotDisplayedReason());
        }
        if (notification.isSkippedMoment()) {
          console.log("Skipped:", notification.getSkippedReason());
        }
      });
    };

    const generateRandom6Digit = () => {
      return Math.floor(100000 + Math.random() * 900000);
    };

    const getRandomState = () => {
      let randomState = sessionStorage.getItem("randomState");
      if (!randomState) {
        randomState = generateRandom6Digit();
        sessionStorage.setItem("randomState", randomState);
      }
      return randomState;
    };
    const { password, username } = basicauth;
    const base64Credentials = btoa(`${username}:${password}`);

    const handleCredentialResponse = async (response) => {
      const decoded = jwtDecode(response.credential);
      const randomState = getRandomState(); // get or generate 6-digit number

      try {
        const requestOptions = {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            accessToken: base64Credentials.toString,
            state: randomState, // pass same number
            userInfo: decoded,
          }),
          redirect: "follow",
        };

        const res = await fetch(
          `https://api.seobix.com/api/GoogleAuth/StoreLoginData`,
          requestOptions
        );
        const data = await res.json();
        console.log("Response:", data);
      } catch (error) {
        console.error("Error ", error);
      }
    };


    if (window.google && window.google.accounts) startOneTap();
    else window.addEventListener("load", startOneTap);

    return () => window.removeEventListener("load", startOneTap);
  }, []);

  return null;
};

export default GoogleOneTapLogin;
